var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('el-row',[_c('section',{staticClass:"articles"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._l((_vm.articlesList),function(articleId){return _c('articles-teaser',{key:articleId,attrs:{"article":_vm.contentMap[articleId],"category":_vm.category}})})],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cf96942","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/articles.vue
// module id = N7/9
// module chunks = 1